import React from 'react';
import Select from "../../input/Select"

interface CareerSelectFilterProps {
  labelStyle: string
  label: string
  onChange: any
  list: JSX.Element[]
}

const CareerSelectFilter = ({ labelStyle, label, onChange, list }: CareerSelectFilterProps) => (
  <Select
    text="All"
    className={labelStyle}
    label={label}
    onChange={onChange}
    firstDisabled={false}
  >
    {list}
  </Select>
)

export default CareerSelectFilter